import { FormEvent } from "react";
import Col from "react-bootstrap/Col";
import { useAppDispatch, useAppSelector } from "../../../services/hooks";
import { fetchNewsletter } from "../../../stores/product/productSlice";
import { useTranslation } from "react-i18next";

export default function ProductInfoNotAvailable() {
    const { t } = useTranslation('productPage')
    const dispatch = useAppDispatch()
    const productName = useAppSelector((state) => state.product.data.id)
    const newsletter = useAppSelector((state) => state.product.data.availabilityInfoRequestSucceed)

    function handleSaveMail(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (productName) {
            const formData = new FormData(e.currentTarget);
            const data = new URLSearchParams();
            for (const [key, value] of formData) {
                data.append(key, value.toString())
            }
            dispatch(fetchNewsletter(data))
        }
    }

    if (newsletter) {
        return (
            <p className="my-4 alert alert-success text-center" role="alert" id="">
                Dziękujemy za pozostawienie swojego adresu.<br />
                Gdy tylko otrzymamy informację o dostępności tego produktu, natychmiast
                Cię o tym poinformujemy.<br />
                <span className="bi bi-emoji-smile"></span>
            </p>
        )
    } else {
        return (
            <Col xs={12} className="text-center my-3 ">
                <form onSubmit={(e) => handleSaveMail(e)}>
                    <p className="m-0 alert alert-success d-none" role="alert" id="productNewsletterMonit">
                        Dziękujemy za pozostawienie swojego adresu.<br />
                        Gdy tylko otrzymamy informację o dostępności tego produktu, natychmiast
                        Cię o tym poinformujemy.<br />
                        <span className="bi bi-emoji-smile"></span>
                    </p>

                    <p className="pt-0 pb-3 fw-bold my-0">
                        {t('productInfo.notAvailable.waiting')}
                    </p>
                    <input type="hidden" name="product" value={productName?.toString()} />
                    <input type="email" name="email" className="form-control text-center" placeholder={t('productInfo.notAvailable.typeMail')} />
                    <p className="py-3 my-0">
                        {t('productInfo.notAvailable.info')}
                    </p>
                    <button type="submit" className="btn btn-lg btn-success rounded-3 py-3 mb-3  mb-md-4  w-100 shadow">
                        <strong className="button-text">{t('productInfo.notAvailable.saveMail')}</strong>
                    </button>
                </form>
            </Col>
        )
    }
}